import Class from './chart-tone-bar';
import './chart-tone-bar@';

export default Class;